import React, { useEffect, useState } from "react";
import Chatheader from "../patientChat/chatheader/chatheader"
import { useStateValue } from '../../../stateprovider';
import "./record.css";
import { useNavigate } from "react-router-dom";
import RecordInfo from "./recordInfo";

const RecordComp = () => {
    const [{ }, dispatch] = useStateValue();
    const navigate = useNavigate();
    const [recordInfoState, setRecordInfoState] = useState(false);

    useEffect(() => {
        dispatch({
            type: "APP_NAV_STATE",
            appnav: true
        });
        dispatch({
            type: "APP_ICON_STATE",
            appIconState: 2
        })
    }, []);

    const recordArray = [
       {
        time: "this month",
        record: [
            {text: "malaria treatment", date: "09/10/2021"},
            {text: "malaria treatment", date: "09/10/2021"}
        ]
       },
       {
        time: "this month",
        record: [
            {text: "malaria treatment", date: "09/10/2021"},
            {text: "malaria treatment", date: "09/10/2021"}
        ]
       },
       {
        time: "this month",
        record: [
            {text: "malaria treatment", date: "09/10/2021"},
            {text: "malaria treatment", date: "09/10/2021"}
        ]
       },
    ];
    const recordinfo = [
        {
            text: "medical treatment", date: "March 12/2012", time: "12:23AM"
        },
        {
            text: "Complain", symptom: ["Toothache", "fever"]
        },
        {
            text: "Symtomps", symptom: ["Swollen gum,", "bad", "breath"]
        },
        {
            text: "Followup",  date: "March 30 2098"
        }
    ]

    return <div className="app_complaint app_extend">
        <div className="app_record_container">
            <div className="app_record_top">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                onClick={()=> {
                    if(recordInfoState){
                        setRecordInfoState(false);
                    }else{
                        navigate(-1)
                    }
                    
                }} style={{cursor: "pointer"}}>

                    <path d="M15 18L9 12L15 6" stroke="#0F0F0F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h4>
                    medical report
                </h4>
            </div>
            {
            recordArray?.length >= 1 ? 
                <>
                { !recordInfoState ?  <div className="app_record_bottom">

                {
                    recordArray.map((record, index) => {
                        return <div className="app_record_row" key={index} >
                        <h5>{record.time}</h5>
                        <div className={index === 0  ? "app_record_col": "app_record_col_disabled"} 
                         style={index === 0 ? {backgroundColor: "#01B6E2", opacity: 1}: {}}>
                            {
                                record.record.map((r, subInddex) => {
                                    return  <div className="app_record_cell" key={subInddex} onClick={()=> setRecordInfoState(true)}>
                                    <p>{r.text}</p>
                                    <p>{r.date}</p>
                                </div>
                                })
                            }
                        </div>
                    </div>
                    })
                }
                </div>
                :
                <RecordInfo record={recordinfo} />}
                </>
                : <div className="app_record_no_para">
              <p>  No medical record found</p>
                </div>
            }
     
        </div>
    </div>
}
export default RecordComp;